import { useNavigate } from "react-router-dom";

import { DidYouKnowScreen } from "../components/DidYouKnowScreen";
import { usePersonalisationData } from "../context/PersonalisationDataContext";

import { SkinSunContainer_PATH } from "./SkinSunContainer";

export const SkinColorFeedbackContainer_PATH =
  "/personalise/skin-color-feedback" as const;

export const SkinColorFeedbackContainer = () => {
  const navigate = useNavigate();
  const { advisorIdentity } = usePersonalisationData();

  return (
    <DidYouKnowScreen
      content={`Your background and skin tone can affect how your skin reacts to certain treatments.\n\nWe'll keep this information in mind when making recommendations for you.`}
      adonisIdentity={advisorIdentity}
      onNext={() => navigate(SkinSunContainer_PATH)}
    />
  );
};
